import React from 'react';

function ProcessingSpinner({
  style={margin: "0 auto 1rem",}
}) {
  return (
    <div className="wait">
      <p className="processing" style={style}></p>
    </div>
  );
}

export default ProcessingSpinner;